import { createHpApp } from '../shared_config';
import PublicLocaleSwitcher from '@/views/public_locale_switcher/index';

window.LocaleSwitcher = createHpApp({
  components: { PublicLocaleSwitcher },
}).mount('#public-locale-switcher');
